/* script */

import Panel                       from 'g3w-panel';
import ApplicationState            from 'g3w-state'
import GUI                         from 'g3w-app';
import { createFilterFromString }  from 'utils/createFilterFromString';
import { getCatalogLayerById }     from 'utils/getCatalogLayerById';

import vueComp                     from 'components/QueryBuilder.vue';
import { gettext as _ }            from 'g3w-i18n';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'search',

  data() {
    return {
      state: this.state || {},
    };
  },

  methods: {
    /**@since 4.1.0  ORIGINAL SOURCE: src/g3w-app.js@v4.0.0*/
    showQueryBuilderPanel() {
      GUI.closeContent();
      GUI.closeSideBar();
      return new Panel({
        title: _('Advanced search'),
        show: true,
        vueComponentObject: vueComp
      });
    },

    showPanel(config = {}) {
      this.$options.service.showPanel(config);
    },

    /**
     * ORIGINAL SOURCE: src/services/querybuilder.js@v3.9.3
     */
    async remove(search, index) {
      const ok = await GUI.confirm(_('Do you want delete it?'));

      if (!ok) {
        return;
      }

      const item     = window.localStorage.getItem('QUERYBUILDERSEARCHES');
      const items    = item ? JSON.parse(item) : undefined;
      const pid      = ApplicationState.project.getId();
      const searches = (items ? items[pid] || [] : []).filter(item => search.id !== item.id);

      if (searches.length) {
        items[pid] = searches;
      } else {
        delete items[pid];
      }

      try {
        if (Object.keys(items).length) {
          window.localStorage.setItem('QUERYBUILDERSEARCHES', JSON.stringify(items));
        } else {
          window.localStorage.removeItem('QUERYBUILDERSEARCHES');
        }
      } catch(e) {
        console.warn(e);
      }

      this.state.querybuildersearches.splice(index, 1); // remove item
    },

    edit(search) {
      const opts = {
        id:            search.id,
        name:          search.name,
        layerId:       search.layerId,
        filter:        search.filter,
        title:         _('Advanced search'),
        show:          true,
      };
      opts.internalPanel = new (Vue.extend(vueComp))({ options: opts });
      new Panel(opts);
    },

    /**
     * ORIGINAL SOURCE: src/services/querybuilder.js@v3.9.3
     */
    async run(search) {
      search.qbloading = true;
      try {
        const layer = getCatalogLayerById(search.layerId);
        await GUI.getData('search:features', {
          inputs: {
            layer,
            filter: createFilterFromString({ layer, filter: search.filter }),
            feature_count: 100,
          },
          outputs: true,
        });
      } catch(e) {
        console.warn(e);
        GUI.showUserMessage({ type: 'alert', message: 'An error occurs. Please check the query', autoclose: true });
      }
      search.qbloading = false;
    },

  },

};


/* template */
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"treeview-menu g3w-search g3w-tools menu-items",attrs:{"id":"g3w-search"}},[_vm._l((_vm.state.searches),function(search){return _c('li',{staticClass:"menu-item",attrs:{"role":"button","tabindex":"0"},on:{"click":function($event){return _vm.showPanel(search)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.stopPropagation();return _vm.showPanel(search)}}},[_c('i',{staticClass:"far fa-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.name))])])}),_vm._v(" "),_vm._l((_vm.state.querybuildersearches),function(search,i){return _c('li',{key:search.id},[_c('div',{staticStyle:{"position":"relative"},on:{"click":function($event){return _vm.edit(search)}}},[(search.qbloading)?_c('div',{staticClass:"bar-loader",staticStyle:{"border":"0"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-tools"},[_c('button',{staticClass:"fas fa-trash",staticStyle:{"color":"red","margin-right":"5px"},attrs:{"type":"button","title":"Delete","data-placement":"bottom"},on:{"click":function($event){$event.stopPropagation();return _vm.remove(search, i)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(search.name))]),_vm._v(" "),_c('button',{staticClass:"fas fa-play",staticStyle:{"color":"green","margin-left":"auto"},attrs:{"type":"button","title":"Run","data-placement":"bottom"},on:{"click":function($event){$event.stopPropagation();return _vm.run(search)}}})])])])}),_vm._v(" "),_c('li',{staticClass:"menu-item",attrs:{"role":"button","tabindex":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.showQueryBuilderPanel.apply(null, arguments)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.stopPropagation();return _vm.showQueryBuilderPanel.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-calculator",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('Advanced search'),expression:"'Advanced search'"}]})])],2)
}
var staticRenderFns = []

const __vue_render__ = render;
const __vue_staticRenderFns__ = staticRenderFns;

const __vue_component__ = __vue_script__;
__vue_component__.render = __vue_render__;
__vue_component__.staticRenderFns = __vue_staticRenderFns__;
__vue_component__._compiled = true;
__vue_component__.__file = "/home/volterra79/G3W-SUITE/g3w-client/src/components/Search.vue";
__vue_component__._scopeId = "data-v-6380fb4c";
/* style inject */
import __vue_create_injector__ from 'g3w-vue:style-injector';
[{"id":"6380fb4c-0","css":"li.menu-item[data-v-6380fb4c]{padding-right:20px!important}li.menu-item span[data-v-6380fb4c]{display:inline-flex;white-space:pre-wrap}#g3w-search li i[data-v-6380fb4c]{width:20px}.search-tools[data-v-6380fb4c]{display:flex;align-items:baseline}.search-tools>span[data-v-6380fb4c]{white-space:pre-wrap}.search-tools>button[data-v-6380fb4c]{text-shadow:0 2px 5px rgba(0,0,0,.3);padding:0 4px;border:none;background-color:unset}\n","media":"","filename":"src/components/Search.vue"}].forEach(__vue_create_injector__());
export default __vue_component__;